<template>
  <iColumn gap="small" width="fill" wrap="nowrap">
    <iSelect
      :model-value="selectedCameraDeviceId"
      :items="cameraItems"
      label="Camera"
      width="fill"
      return-value
      :empty-string="describeEmptyState(availableVideoDevices, 'videoinput')"
      :disabled="!cameraItems.length"
      data-test="settings-camera-select"
      @update:model-value="$emit('change-camera', $event)"
    />
    <iToggleSwitch
      :model-value="isLocalVideoMirrored"
      label="Mirror my video"
      description="Only you see the mirrored view; others see you as you are."
      size="small"
      data-test="settings-mirror-toggle"
      @update:model-value="$emit('toggle-mirror', $event)"
    />
  </iColumn>
</template>

<script>
import { describeDevices, describeEmptyState } from "%/apps/video-engine/device-catalog";

export default {
  name: "VideoSettingsSection",
  props: {
    availableVideoDevices: {
      type: Array,
      default: () => [],
    },
    selectedCameraDeviceId: {
      type: String,
      default: null,
    },
    isLocalVideoMirrored: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["change-camera", "toggle-mirror"],
  computed: {
    cameraItems() {
      return describeDevices(this.availableVideoDevices, "videoinput");
    },
  },
  methods: {
    describeEmptyState,
  },
};
</script>
